// import LogRocket from 'logrocket';
import { WebMediaQuery } from '@aperza/ui';
import { AppConfigService, AppService } from '@aperza/util';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import CartBadge from '../cart/CartBadge';
import AppLinkContainer from '../common/AppLinkContainer';
import Brand from '../common/Brand';
import Suggest from '../suggest/Suggest';
import SuggestPopUp from '../suggest/SuggestPopUp';
import UserMenu from './UserMenu';
import UserMenuLoader from './UserMenuLoader';
const appConfig = AppService.appConfig();
const QUERY = gql `
  query UserMenuQuery {
    viewer {
      userId
      locale
      serverTime
      displayName
      companyName
      isLogin
      isBusiness
      isActiveBusiness
      buyer {
        approvalFlag
      }
      unreadMessageCount
    }
  }
`;
const UserSection = (props) => {
    const { viewer, suggestSearch, disableSuggest, disableLogin, disableCartBadge } = props;
    const [suggestKeyword, setSuggestKeyword] = useState(AppConfigService.getSearchKeyword() ? AppConfigService.getSearchKeyword() : '');
    const [showSuggest, setShowSuggest] = useState(false);
    const onSuggestChange = (keyword) => {
        setSuggestKeyword(keyword);
    };
    const onClickSuggestPopUp = () => {
        setShowSuggest(!showSuggest);
    };
    const renderSuggest = () => {
        const tdComponentName = 'header_searchBox';
        let suggest;
        if (!disableSuggest) {
            suggest = (React.createElement(Suggest, { tdId: `td-parts-td-${tdComponentName}`, suggestSearch: suggestSearch, suggestKeyword: suggestKeyword, onSuggestChange: onSuggestChange, ...props }));
        }
        return suggest;
    };
    const suggest = renderSuggest();
    return (React.createElement("div", { className: "stripColumn" },
        React.createElement("div", { className: "aw-main strip" },
            React.createElement(Brand, null),
            !disableSuggest && (React.createElement(WebMediaQuery, { desktopOnly: true },
                React.createElement("div", null, suggest))),
            React.createElement("div", { className: "util-container" },
                true || (appConfig.isAperzaCatalogTop && React.createElement(AppLinkContainer, null)),
                !disableSuggest && (React.createElement(WebMediaQuery, { mobileOnly: true },
                    React.createElement("div", { className: "util-item" },
                        React.createElement(SuggestPopUp, { suggest: suggest, onClick: onClickSuggestPopUp })))),
                (!viewer.isBusiness || viewer.isActiveBusinessCart) && (React.createElement("div", { className: "util-item" }, !disableCartBadge && React.createElement(CartBadge, { viewer: viewer }))),
                React.createElement("div", { className: "util-item" }, !disableLogin && React.createElement(UserMenuLoader, { viewer: viewer })))),
        (AppConfigService.isAperzaSearchResultPage() ||
            AppConfigService.isAperzaSearchNewsResultPage() ||
            showSuggest) && (React.createElement("div", { className: "suggest-mobile" }, !disableSuggest && React.createElement(WebMediaQuery, { mobileOnly: true }, suggest)))));
};
UserSection.propTypes = {
    viewer: PropTypes.any,
    suggestSearch: PropTypes.any,
    disableSuggest: PropTypes.bool,
    disableCartBadge: PropTypes.bool,
    disableLogin: PropTypes.bool,
    disableMarketplaceBanner: PropTypes.bool,
};
UserSection.defaultProps = {
    viewer: {},
};
UserSection.fragments = {
    viewer: gql `
    fragment UserSection_viewer on Viewer {
      id
      userId
      isInternalIp
      isLogRocket
      isLogin
      isBusiness
      isActiveBusinessCart
      ...UserMenu_viewer
    }
    ${UserMenu.fragments.viewer}
  `,
};
export default UserSection;
